import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import queryString from 'query-string';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import database from '@app/services/database';
import GrantHistoryView from './GrantHistoryView';

import { CompileTOVS } from "@app/utils/CompileTOVS";
import { saveAs } from "file-saver";
import { Packer } from "docx";
import { DocumentCreator } from "@app/utils/DocumentCreator";

class ConnectedGrantHistoryContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: this.props.locale ? this.props.locale : 'en',
            pageLoad: '',
            // Grant History
            grantHistory: '',
            grantAmount: '',
            validationErrors: {
                grantHistory: { show: false, check: null, errorMessage: ''  },
                grantAmount: { show: false, check: null, errorMessage: ''  }
            },
            isLoading: false,
            errorMessage: '',
            successMessage: '',
            loadToSubmitTime: '',
            shareMessage: ''
        };

        // Grant History
        this.handleGrantHistory = this.handleGrantHistory.bind(this);
        this.handleGrantAmount = this.handleGrantAmount.bind(this);
        this.generateDoc = this.generateDoc.bind(this);
    }

    componentDidMount() {
        if (this.state.pageLoad === '') {
            this.setState({
                pageLoad: new Date().valueOf()
            });
        }
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).startsWith('tovsForm.grant.')) {
                this.setState({
                    [localStorage.key(i).substring(15)]: localStorage.getItem(localStorage.key(i))
                });
            }
        }
    }

    handleGrantHistory(e) {
        let value = e.target.value;
        let  validationErrors = this.state. validationErrors;
         validationErrors.grantHistory.check = true;
        this.setState({ 
            grantHistory: e.target.value,
             validationErrors:  validationErrors
        });
        localStorage.setItem('tovsForm.grant.grantHistory', value);
    }

    handleGrantAmount(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isGrantAmountValid = value < 200001;

        if (isGrantAmountValid) {
            validationErrors.grantAmount.check = true;
            validationErrors.grantAmount.errorMessage = '';
        }
        else {
            validationErrors.grantAmount.check = false;
            validationErrors.grantAmount.errorMessage = 'If you have received more than €200,000 over a 3 year period, you may be ineligible.';
        }
        validationErrors.grantAmount.show = !isGrantAmountValid;
        this.setState({
            grantAmount: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.grant.grantAmount', value);
    }

    generateDoc() {
        const data = new CompileTOVS().compile(); 
        var documentCreator = new DocumentCreator();
        var doc = documentCreator.create(data);

        Packer.toBlob(doc).then(function (blob) {
            saveAs(blob, "TradingOnlineVoucherScheme-" + Date.now() + ".docx");
        });
    }

    generateViewProps() {
        return {
            ...this.state,
            // Grant History
            handleGrantHistory: this.handleGrantHistory,
            handleGrantAmount: this.handleGrantAmount,
            generateDoc: this.generateDoc
        };
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <GrantHistoryView {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLocale: locale => dispatch(setLocale(locale))
    };
};

const GrantHistoryContainer = injectIntl(connect(mapStateToProps,mapDispatchToProps)(ConnectedGrantHistoryContainer));

export default GrantHistoryContainer;